import React from 'react';
import PropTypes from 'prop-types';

const StepReview = ({
  formData
}) => {

  const FieldDisplay = ({ label, value }) => (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-1">
        <span className="text-xs font-medium text-text-secondary">{label}</span>
        {!value && (
          <span className="text-xs bg-yellow-500/20 text-yellow-400 px-2 py-0.5 rounded">
            Will be auto-generated
          </span>
        )}
      </div>
      {value ? (
        <div className="text-sm text-text-primary bg-bg-tertiary p-3 rounded border border-border-primary font-mono text-xs whitespace-pre-wrap">
          {value}
        </div>
      ) : (
        <div className="text-sm text-text-secondary italic">AI will generate this field</div>
      )}
    </div>
  );

  FieldDisplay.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string
  };

  return (
    <div className="wizard-step">
      <div className="step-intro">
        <h3>Review & Create</h3>
        <p>Review your prompt before creating. Empty fields will be auto-generated by AI.</p>
      </div>
      
      <div className="review-content">

      {/* Prompts */}
      <div className="review-section">
        <h4 className="review-section-title">Prompts</h4>
        {formData.system_prompt && (
          <FieldDisplay
            label="System Prompt"
            value={formData.system_prompt}
          />
        )}
        <FieldDisplay
          label="User Prompt"
          value={formData.user_prompt}
        />
        {formData.few_shot_examples && (
          <FieldDisplay
            label="Few-Shot Examples"
            value={formData.few_shot_examples}
          />
        )}
      </div>

      {/* Variables */}
      {formData.variables.length > 0 && (
        <div className="review-section">
          <h4 className="review-section-title">
            Variables ({formData.variables.length})
          </h4>
          <div className="space-y-2">
            {formData.variables.map((variable, index) => (
              <div key={index} className="bg-bg-tertiary p-3 rounded border border-border-primary">
                <div className="flex items-center justify-between mb-1">
                  <code className="text-xs text-primary-400">{'{{ ' + variable.name + ' }}'}</code>
                  <div className="flex gap-2 items-center">
                    {!variable.description && (
                      <span className="text-xs bg-yellow-500/20 text-yellow-400 px-2 py-0.5 rounded">
                        Auto-gen
                      </span>
                    )}
                    <span className="text-xs text-text-secondary">{variable.type}</span>
                    {variable.required && (
                      <span className="text-xs text-red-400">Required</span>
                    )}
                  </div>
                </div>
                <p className="text-xs text-text-secondary">
                  {variable.description || <em>Will be auto-generated</em>}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Metadata */}
      <div className="review-section">
        <h4 className="review-section-title">Metadata</h4>
        <FieldDisplay
          label="Use Case"
          value={formData.use_case}
        />
        <FieldDisplay
          label="Description"
          value={formData.description}
        />
      </div>

      {/* Configuration */}
      <div className="review-section">
        <h4 className="review-section-title">Configuration</h4>
        <FieldDisplay
          label="Output Constraints"
          value={formData.output_constraints}
        />
        <FieldDisplay
          label="Must Include"
          value={formData.must_include}
        />
        <FieldDisplay
          label="Must Avoid"
          value={formData.must_avoid}
        />
        <FieldDisplay
          label="Special Instructions"
          value={formData.special_instructions}
        />
      </div>
      </div>
    </div>
  );
};

StepReview.propTypes = {
  formData: PropTypes.object.isRequired,
};

export default StepReview;

